import { Box } from '@mui/material';

import { normalizeSx } from '@/utils/normalizeSx';

import type { SxProps, Theme } from '@mui/material/styles';

type TagProps = {
  label?: string;
  sx?: SxProps<Theme>;
};

export const Tag = ({ label = 'beta', sx }: TagProps) => {
  return (
    <Box
      sx={[
        {
          backgroundColor: label === 'beta' ? 'gx.actionBarButtonTile' : 'primary.main',
          fontSize: '8px',
          textTransform: 'uppercase',
          display: 'inline-flex',
          justifyContent: 'center',
          alignItems: 'center',
          lineHeight: 1,
          px: '4px',
          minWidth: '36px',
          letterSpacing: '0.16px',
          height: '12px'
        },
        ...normalizeSx(sx)
      ]}
    >
      <span>{label}</span>
    </Box>
  );
};
